<template>
  <div>
    <div
      v-for="(iconRow, rowIndex) in [iconsRowOne, iconsRowTwo, iconsRowThree]"
      :key="rowIndex"
      :class="['size-xl display-flex flex-content-around', { 'margin-y-4xs': rowIndex === 0 || rowIndex === 2, 'margin-y-sm': rowIndex === 1 }]"
    >
      <span
        v-for="(icon, iconIndex) in iconRow"
        :key="iconIndex"
      >
        <font-awesome-icon
          :icon="getIconString(fullStyleName, icon)"
        />
      </span>
    </div>
  </div>
</template>

<script>
  import { getIconString } from './styleCardData.js'
  export default {
    name: 'IconGrid',

    props: {
      fullStyleName: {
        type: String
      },
      iconsRowOne: {
        type: Array
      },
      iconsRowTwo: {
        type: Array
      },
      iconsRowThree: {
        type: Array
      },
      isVertical: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      getIconString
    }
  }
</script>
